import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, take } from 'rxjs';
import { AccountService } from './account';

export const authGuard: CanActivateFn = (route, state) => {
  const accountService = inject(AccountService);
  const oidcSecurityService = inject(OidcSecurityService);

  accountService.originalRoute = state.url;

  // checkAuth() already ran once at bootstrap (withAppInitializerAuthCheck),
  // so just read the current auth state — don't re-run it on every navigation.
  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => {
      if (isAuthenticated) {
        return true;
      }

      oidcSecurityService.authorize();
      return false;
    })
  );
};
